import { all } from 'redux-saga/effects';
import gtagSagas from './gtag';
import identifySagas from './identify';
import pageSagas from './page';
import utmSagas from './utm';

export default all([gtagSagas, identifySagas, pageSagas, utmSagas]);
